import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import HeroContent, { HeroHighlight }
  from '@fuww/library/src/SplitSection/HeroContent';
import messages from '../lib/messages.json';
import SplitHero from './SplitHero';

const heroImageUrls = {
  desktop: [
    'https://r.fashionunited.com/LvGSNbBqixuqTXPCPnqO_PztrYWhhoekGuFeAxNoJ5M/resize:fill-down:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
    'https://r.fashionunited.com/Bgj_bamakHf3_PoJvF54FGHuiO8m-66QUAFPsAqflAE/resize:fill-down:480:384:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
    'https://r.fashionunited.com/dmSYSndWm4gWq1fz92ec_3dTxetPfa0roPQXsuOW6FI/resize:fill-down:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
    'https://r.fashionunited.com/HLdrU79JAl_OkGHn1-0EUjyQvZ7NiGD_v4U3brYCgKY/resize:fill-down:1280:1024:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
  ],
  mobile: [
    'https://r.fashionunited.com/pSlSQPgFcjxv3N_vt0LsQb0MwfKsoVuvAkLUqvxHtac/resize:fill-down:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
    'https://r.fashionunited.com/SUSIsv26p5kQfPu2nVmgUNXR1ai5tikNKcXP7DoIzpY/resize:fill-down:480:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
    'https://r.fashionunited.com/JZjgxmRf0xsUu8AZ4qlRvyoLNMjFp4EoNFVkLUNMszQ/resize:fill-down:720:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
    'https://r.fashionunited.com/UFLFXtTldwErAGQ8oC6rcz1JFFpaUQqWrX1V1emdkKA/resize:fill-down:1280:0:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvcHJlbWl1bS1lbXBsb3llci1oZXJvLWltZy5wbmc',
  ],
};

const renderHighlight = (chunks: ReactNode) => (
  <HeroHighlight>{chunks}</HeroHighlight>
);

const PremiumEmployerHero = () => {
  const intl = useIntl();

  return (
    <SplitHero
      imageUrls={heroImageUrls}
      alt={intl.formatMessage(messages['premiumEmployer.heroAlt'])}
      content={(
        <HeroContent
          eyebrow={
            intl.formatMessage(messages['premiumEmployer.heroEyebrow'])
          }
          headline={intl.formatMessage(
            messages['premiumEmployer.heroHeadline'],
            { highlight: renderHighlight },
          )}
          description={
            intl.formatMessage(messages['premiumEmployer.heroDescription'])
          }
        />
      )}
    />
  );
};

export default PremiumEmployerHero;
